import { useEffect } from 'react'

import download_pwa from '../../assets/common/download_pwa.webp'
import { useBoundStore } from '../../store/store'
import { isSafari } from '../../utils/device'
import Icon from '../icon'

const DownloadPwa = () => {
  const isDownloadPwaVisible = useBoundStore(
    state => state.common.isDownloadPwaVisible,
  )
  const setIsDownloadPwaVisible = useBoundStore(
    state => state.common.setIsDownloadPwaVisible,
  )

  useEffect(() => {
    if (
      isSafari() &&
      !window.matchMedia('(display-mode: standalone)').matches
    ) {
      setIsDownloadPwaVisible(true)
    }
  }, [])

  if (!isDownloadPwaVisible) return null

  return (
    <div className="relative cursor-pointer flex mb-[5px]">
      <img className="w-[50px]" src={download_pwa} id="pwa-icon" />
      <button
        className="flex absolute cursor-pointer -right-0.5 -top-3.5"
        id="pwa-icon-close">
        <Icon
          className="pointer-events-none fill-txt"
          id="close"
          width="10"
          height="10"
        />
      </button>
    </div>
  )
}

export default DownloadPwa
